var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 17.25C6.225 17.25 6.75 17.775 6.75 18.375C6.75 18.975 6.225 19.5 5.625 19.5C5.025 19.5 4.5 18.975 4.5 18.375C4.5 17.775 5.025 17.25 5.625 17.25ZM5.625 15.75C4.2 15.75 3 16.95 3 18.375C3 19.8 4.2 21 5.625 21C7.05 21 8.25 19.8 8.25 18.375C8.25 16.95 7.05 15.75 5.625 15.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 17.25C18.225 17.25 18.75 17.775 18.75 18.375C18.75 18.975 18.225 19.5 17.625 19.5C17.025 19.5 16.5 18.975 16.5 18.375C16.5 17.775 17.025 17.25 17.625 17.25ZM17.625 15.75C16.2 15.75 15 16.95 15 18.375C15 19.8 16.2 21 17.625 21C19.05 21 20.25 19.8 20.25 18.375C20.25 16.95 19.05 15.75 17.625 15.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.5V6.25C15.75 5.69772 15.3023 5.25 14.75 5.25H3.25C2.69772 5.25 2.25 5.69772 2.25 6.25V15.5C2.25 16.0523 2.69772 16.5 3.25 16.5H20.75C21.3023 16.5 21.75 16.0523 21.75 15.5V12.75C21.75 10.7939 20.2804 9.0478 18.896 7.64681C18.8028 7.55249 18.6755 7.5 18.5429 7.5H15.75",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.75C13.1642 9.75 13.5 9.41421 13.5 9C13.5 8.58579 13.1642 8.25 12.75 8.25C12.3358 8.25 12 8.58579 12 9C12 9.41421 12.3358 9.75 12.75 9.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12.75H4.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9H10.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/DeliveryIcon.48f52bea.svg";
export { ForwardRef as ReactComponent };